"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.otherInformation = exports.medicalHistoryConfig = exports.conditionDefinitions = exports.MedicalHistoryDefinition = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _types = require("../../types");

var _config = require("../config");

var _fieldDefinitionTypes = require("../../fields/config/fieldDefinitionTypes");

var _receivedBloodTransfusionConfig = require("./ReceivedBloodTransfusion/receivedBloodTransfusionConfig");

var _refusedBloodDonorConfig = require("./RefusedBloodDonor/refusedBloodDonorConfig");

var _conditionConfig = require("./Condition/conditionConfig");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var TextfieldDefinition = _flowRuntime["default"].tdz(function () {
  return _fieldDefinitionTypes.TextfieldDefinition;
});

var ComponentConfigDefinition = _flowRuntime["default"].tdz(function () {
  return _config.ComponentConfigDefinition;
});

var ComponentElementDefinition = _flowRuntime["default"].tdz(function () {
  return _types.ComponentElementDefinition;
});

var otherInformation = {
  key: 'otherInformation',
  type: 'text',
  hideLabel: true,
  description: 'Please provide any other information or comments on your health, including medications and operations which have not been mentioned.'
};
exports.otherInformation = otherInformation;
var conditions = [{
  key: 'anaemia',
  label: 'Anaemia'
}, {
  key: 'arthritis',
  label: 'Arthritis'
}, {
  key: 'asthma',
  label: 'Asthma or breathing problems'
}, {
  key: 'backAndNeck',
  label: 'Back and neck pain including fractures'
}, {
  key: 'bleeding',
  label: 'Bleeding problems'
}, {
  key: 'bloodClots',
  label: 'Blood clots or deep vein thrombosis'
}, {
  key: 'colitis',
  label: 'Colitis'
}, {
  key: 'depression',
  label: 'Depression'
}, {
  key: 'eczema',
  label: 'Eczema'
}, {
  key: 'heartMurmurs',
  label: 'Heart Murmurs'
}, {
  key: 'highBlood',
  label: 'High blood pressure'
}, {
  key: 'malaria',
  label: 'Malaria'
}, {
  key: 'me',
  label: 'ME'
}, {
  key: 'psoriasis',
  label: 'Psoriasis'
}, {
  key: 'severeAllergies',
  label: 'Severe allergies'
}, {
  key: 'sickleCell',
  label: 'Sickle cell trait or thalassaemia trait'
}, {
  key: 'slippedDiscs',
  label: 'Slipped discs'
}, {
  key: 'tuberculosis',
  label: 'Tuberculosis'
}];

var createConditionDefinition = function createConditionDefinition(condition) {
  return {
    key: condition.key,
    label: condition.label,
    type: 'condition'
  };
};

var conditionDefinitions = conditions.map(function (condition) {
  return createConditionDefinition(condition);
});
exports.conditionDefinitions = conditionDefinitions;
var medicalHistoryConfig = {
  type: 'medicalHistory',
  key: 'medicalHistory',
  subComponents: [_refusedBloodDonorConfig.refusedBloodDonor, _receivedBloodTransfusionConfig.receivedBloodTransfusion].concat((0, _toConsumableArray2["default"])(conditionDefinitions)),
  fields: [otherInformation]
};
exports.medicalHistoryConfig = medicalHistoryConfig;

var MedicalHistoryDefinition = _flowRuntime["default"].type("MedicalHistoryDefinition", _flowRuntime["default"].spread(_flowRuntime["default"].ref(ComponentElementDefinition), _flowRuntime["default"].object(_flowRuntime["default"].property("type", _flowRuntime["default"].string("medicalHistory")))));

exports.MedicalHistoryDefinition = MedicalHistoryDefinition;